<script setup>
import { ref, computed, watch, inject } from 'vue'
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'
import { vOnClickOutside } from '@vueuse/components'
import { useRoute } from 'vue-router'
import MdiArrowExpand from 'vue-material-design-icons/ArrowExpandHorizontal.vue'
import MdiArrowCollapse from 'vue-material-design-icons/ArrowCollapseHorizontal.vue'

const route = useRoute()

const fullMenu = ref(true)

const menuVisible = defineModel()

const breakpoints = useBreakpoints(breakpointsTailwind)

const smallScreen = breakpoints.smallerOrEqual('md') //ref

const calculatedMenuClasses = computed(() => {
  if (!smallScreen.value) {
    if (fullMenu.value) {
      return 'w-48'
    } else {
      return 'w-14'
    }
  }
  return null
})

function closeSmMenu() {
  menuVisible.value = false
}

function switchMenuWidth() {
  fullMenu.value = !fullMenu.value
}

const isMenuActive = (key) => {
  return route.meta.menuKey === key
}

const onClickOutsideHandler = [
  () => {
    closeSmMenu()
  },
  { ignore: ['#navMenuButton'] }
]

watch(smallScreen, (newValue) => {
  if (newValue) {
    menuVisible.value = false
  }
})

const menuData = inject('menuData')
</script>

<template>
  <div
    v-if="!smallScreen || menuVisible"
    class="md:flex md:flex-col md:grow md:h-full z-20 bg-highlight text-color shadow md:static absolute"
    :class="calculatedMenuClasses"
    v-on-click-outside="onClickOutsideHandler"
  >
    <div class="basis-full md:basis-px grow overflow-y-scroll">
      <RouterLink
        v-for="(position, index) in menuData"
        :key="index"
        v-slot="{ href, navigate }"
        custom
        :to="position.route"
      >
        <div
          v-pv-tooltip="{
            value: position.label,
            disabled: fullMenu || smallScreen,
            showDelay: 700
          }"
          class="flex flex-row rounded m-1.5 px-2.5 py-2 hover:bg-highlight-emphasis overflow-clip"
          :class="isMenuActive(position.key) ? 'bg-primary' : ''"
          @click="closeSmMenu()"
        >
          <a
            class="flex text-color no-underline"
            :href="href"
            @click="navigate"
          >
            <component
              :is="position.icon"
              :title="position.label"
              class="pr-4"
            />
            <div class="whitespace-nowrap inline">{{ position.label }}</div>
          </a>
        </div>
      </RouterLink>
    </div>
    <div class="md:block hidden">
      <div class="flex flex-row px-4 py-2">
        <mdi-arrow-collapse
          v-if="fullMenu"
          @click="switchMenuWidth"
        />
        <mdi-arrow-expand
          v-else
          @click="switchMenuWidth"
        />
      </div>
    </div>
  </div>
</template>
